'use strict';

exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' ? Component : 'Component');
};

exports.default = getDisplayName;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-display-name/lib/getDisplayName.js
 ** module id = 644
 ** module chunks = 0
 **/